"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFieldTooltip = void 0;
const react_1 = require("react");
const lib_1 = require("use-debounce/lib");
const component_size_1 = require("../../utils/component-size");
function isEllipsisActive(ref) {
    const current = ref.current;
    return current !== null
        ? current.offsetWidth + 1 < current.scrollWidth // + 1 to prevent rounding errors
        : false;
}
function useFieldTooltip(value = '') {
    const tooltipRef = (0, react_1.useRef)(null);
    const [withTooltip, setWithTooltip] = (0, react_1.useState)(false);
    const { width } = (0, component_size_1.useComponentSize)(tooltipRef);
    const [debouncedWidth] = (0, lib_1.useDebounce)(width, 500);
    (0, react_1.useLayoutEffect)(() => {
        setWithTooltip(isEllipsisActive(tooltipRef));
    }, [value, debouncedWidth]);
    return { withTooltip, tooltipRef };
}
exports.useFieldTooltip = useFieldTooltip;
//# sourceMappingURL=tooltip-field-hook.js.map